angular.module("vgresiduos").component("jobPositionSelect", {
	controller: "JobPositionCtrl",
	templateUrl: "views/components/fields/jobPositionSelect/jobPositionSelect_template.html",
	bindings: {
		label: "@?",
		helpInfo: "@",
		emptyField: "<?",
		setterId: "<?",
		model: "=",
		isRequired: "<?",
		isDisabled: "<?",
		selectAutoWhenOneOption: "<?"
	}
});
